

export class CharacteristicRowClassName {
  [characteristicName : string]: string;
}
